export type HomeSurface = "member" | "contact-centre" | "operations" | "onboarding" | "no-access";

const STORAGE_PREFIX = "thrive_home_surface:";
const STORED_SURFACES = new Set<HomeSurface>(["member", "contact-centre", "operations"]);

export function homeSurfaceStorageKey(userId: string): string {
  return `${STORAGE_PREFIX}${userId}`;
}

export function resolveHomeSurface(input: {
  onboarded: boolean;
  hasCompanion: boolean;
  hasContactCentre: boolean;
  hasOperations: boolean;
  lastUsed: HomeSurface | null;
}): HomeSurface {
  if (input.hasCompanion) {
    if (!input.onboarded) {
      return input.hasContactCentre ? "contact-centre" : "onboarding";
    }
    if (input.hasContactCentre) {
      if (input.lastUsed === "member") return "member";
      if (input.lastUsed === "operations" && input.hasOperations) return "operations";
      return "contact-centre";
    }
    if (input.lastUsed === "operations" && input.hasOperations) return "operations";
    return "member";
  }

  if (input.hasContactCentre) return "contact-centre";
  if (input.hasOperations) return "operations";
  return "no-access";
}

export function readLastUsedHomeSurface(userId: string | null | undefined): HomeSurface | null {
  if (!userId) return null;
  try {
    const value = localStorage.getItem(homeSurfaceStorageKey(userId));
    if (value && STORED_SURFACES.has(value as HomeSurface)) return value as HomeSurface;
    return null;
  } catch {
    return null;
  }
}

export function writeLastUsedHomeSurface(
  userId: string | null | undefined,
  surface: "member" | "contact-centre",
): void {
  if (!userId) return;
  try {
    localStorage.setItem(homeSurfaceStorageKey(userId), surface);
  } catch {
    /* storage unavailable */
  }
}
